import React, { useState } from 'react';
import {
  Contact,
  ContactMediumType,
} from '../../../api/ContactListening/schema';
import Pagination from '@amzn/meridian/pagination';
import ChatMedium from './ChatMedium';
import Column from '@amzn/meridian/column';
import RecordingMedium from './RecordingMedium';
import Text from '@amzn/meridian/text';
import { FormattedMessage } from 'react-intl';
import { CLClickstream } from '../utils/ContactListeningHelpers';
import EmailMedium from './EmailMedium';
import CoachingEmptyState from '../../../Assets/coachingEmptyState.png';

export interface EscalationMediumProps {
  contacts: Contact[] | undefined;
  contactListeningParams: any | undefined;
  CLClickstream: CLClickstream;
  contactType: ContactMediumType;
}

export const EscalationMedium: React.FC<EscalationMediumProps> = ({
  contacts,
  contactListeningParams,
  CLClickstream,
  contactType,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const oneContact = contacts?.length === 1;

  const contactMediumTriage = (contacts: Contact[], oneContact: boolean) => {
    switch (contactType) {
      case ContactMediumType.CHAT:
        return (
          <ChatMedium
            contact={oneContact ? contacts[0] : contacts[currentPage - 1]}
          />
        );
      case ContactMediumType.PHONE:
        return (
          <RecordingMedium
            contact={oneContact ? contacts[0] : contacts[currentPage - 1]}
            contactListeningParams={contactListeningParams}
            isEscalation={true}
            CLClickstream={CLClickstream}
          />
        );

      case ContactMediumType.EMAIL:
        return (
          <EmailMedium
            contact={oneContact ? contacts[0] : contacts[currentPage - 1]}
          />
        );
    }
  };

  return (
    <>
      {!contacts || !contacts.length || !contacts[0].medium ? (
        <Column alignmentHorizontal='center' alignmentVertical='center'>
          <div>
            <img src={CoachingEmptyState} alt='no contacts' />
          </div>
          <Text>
            <FormattedMessage
              id='cs_perfportal_contact_listening_no_escalation'
              defaultMessage='There are no escalations to display here at the moment.'
            />
          </Text>
        </Column>
      ) : (
        <>
          {contactMediumTriage(contacts, oneContact)}
          {!oneContact && (
            <Column heights='fill' alignmentHorizontal='center'>
              <Pagination
                numberOfPages={contacts.length}
                onChange={setCurrentPage}
                currentPage={currentPage}
              />
            </Column>
          )}
        </>
      )}
    </>
  );
};
export default EscalationMedium;
